import React, { useEffect, useState } from "react";
import styles from "./SearchInput.module.css";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import TextInput from "../forms/TextInput/TextInput";
import IconSearch from "../icons/IconSearch";

type SearachInputProps = {
  searchTerm: string;
  onDebounceChange: (value: string) => void,
  searchLoading?: boolean,
  placeholder: string,
  className?: string;
};

const SearachInput = ({
  searchTerm,
  onDebounceChange,
  searchLoading = false,
  placeholder,
  className='',
}: SearachInputProps) => {
  const [term, setTerm] = useState<string>(searchTerm);
  const [debounceCounter, setDebounceCounter] = useState<number>(0);

  const debounce = (delay: number) => {
    let timeoutId: ReturnType<typeof setTimeout>;
    return function() {
      setDebounceCounter((prevCounter) => prevCounter + 1);
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setDebounceCounter((prevCounter) => prevCounter - 1);
      }, delay);
    };
  };

  const debounceHandleChange = debounce(350);

  const handleOnChange = (val: string) => {
    debounceHandleChange();
    setTerm(val);
  };

  useEffect(() => {
    if (debounceCounter === 0) onDebounceChange(term);
  }, [debounceCounter, term, onDebounceChange]);

  useEffect(() => {
    if (!searchTerm) setTerm("");
  }, [searchTerm]);

  return (
    <div className={`${styles.searchContainer} ${className}`}>
      <TextInput
        className={styles.searchInput}
        placeholder={placeholder}
        prefix={<IconSearch />}
        value={term}
        inputAutofocus
        onChange={(value) => handleOnChange(value)}
      />
      {(searchLoading || debounceCounter !== 0) && (
        <div className={styles.spinnerContainer}>
          <LoadingSpinner size="1.5rem" />
        </div>
      )}
    </div>
  );
};

export default SearachInput;
